module.exports = __webpack_public_path__ + "img/home_image_4-mobile.a25cfbe4.webp";